module.exports = __webpack_public_path__ + "static/media/wizualizacja-77.da670461.png";